export enum AuthActionType {
  Reset = '[cpc/auth] Reset',

  SendVerificationCode = '[cpc/auth] Send Verification Code',
  SendVerificationCodeFailed = '[cpc/auth] Send Verification Code Failed',
  SendVerificationCodeFulfilled = '[cpc/auth] Send Verification Code Fulfilled',

  SetVerificationMethod = '[cpc/auth] Set Verification Method',

  SignIn = '[cpc/auth] Sign In',
  SignInFailed = '[cpc/auth] Sign In Failed',
  SignInFulfilled = '[cpc/auth] Sign In Fulfilled',

  Verify = '[cpc/auth] Verify',
  VerificationFailed = '[cpc/auth] Verification Failed'
}
